import { render } from "./Decont.vue?vue&type=template&id=d7a7fac8&scoped=true&ts=true"
import script from "./Decont.vue?vue&type=script&lang=ts"
export * from "./Decont.vue?vue&type=script&lang=ts"

import "./Decont.vue?vue&type=style&index=0&id=d7a7fac8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7a7fac8"]])

export default __exports__